import { Command, HttpMethod } from "~/extensions/api";
export class GetAdminInformationCommand extends Command {
    constructor(informationNo) {
        super(HttpMethod.Get, `information/admin/${informationNo}`);
    }
}
